import { useState } from "react";
import { IFormInput } from "../../interfaces";
import { EyeIcon, EyeOff } from "lucide-react";

export const GaFormInput = ({ value, onChange, error, isPassword, label, disabled, placeholder, inputRef, fullWidth, autocomplete, className }: IFormInput) => {
    const [previewPassword, setPreviewPassword] = useState<boolean>(false);

    const inputClassName = isPassword ? "ar-ga-right-icon-input" : "";

    return (
        <div className="ga-form-field ar-ga-form-field">
            <input
                ref={inputRef}
                type={isPassword && !previewPassword ? "password" : "text"}
                placeholder={placeholder}
                className={`ga-input ${className} ${inputClassName}`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                aria-label={label}
                autoComplete={autocomplete ? autocomplete : "on"}
                disabled={disabled}
            />

            {isPassword && !disabled && value?.length > 0 &&
                <span 
                    className="ar-ga-preview-icon"
                    data-testid="preview-icon"
                    onClick={() => { setPreviewPassword(!previewPassword); }}>
                        {previewPassword ? <EyeOff size={24} color="var(--ga-color-icon-primary)" /> : <EyeIcon size={24} color="var(--ga-color-icon-primary)" />}
                </span>
            }
        </div>
    );
};
